import store from "../store";
import utils from ".";

// TODO log if any error occurs in promises and check in other files

const launch = async function checkAppRequirementsBeforeStartApp(
  fetchUser = true
) {
  const promises = [];

  if (fetchUser) promises.push(store.dispatch("fetch_user"));
  promises.push(store.dispatch("get_configs"));
  // promises.push(store.dispatch("get_premium_subscription"));

  await Promise.all(promises)
    .then(() => store.commit("toggle_launcher", true))
    .catch((err) => utils.handleErrorIfKnown(err?.message));

  store.state.showSnackbar = false; // close snack if opened before launcher
};

export default launch;
